function getConsent(): boolean | undefined {
  let analyticsConsent;
  window.cmp.addEventListener(
    window.ParamountCmp.PrivacyEvent.CONSENT_READY,
    () => {
      // query analytics category consent
      analyticsConsent = window.cmp.consent.getConsent(
        window.ParamountCmp.ConsentCategory.ANALYTICS,
      );
    },
  );
  return analyticsConsent;
}

const Tracker = {
  setVideoData: (data: Record<string, unknown>) => {
    if (window.om && window.om.setVideoData && getConsent()) {
      window.om.setVideoData(data);
    }
  },
  trackPage: (data: Record<string, unknown>) => {
    if (window.om && window.om.trackState && getConsent()) {
      window.om.trackState(data);
    }
  },
  trackEvent: (eventName: string, data: Record<string, unknown>) => {
    // At time of writing, the trackAction property is currently unavailable
    // TODO: Check and update this if necessary before implementation
    // if (window.om && window.om.trackAction) {
    //   window.om.trackAction(data);
    // }

    // Using trackState since M-OPS does not want to expose trackAction
    if (window.om && window.om.trackState && getConsent()) {
      window.om.trackState({ ...data, linkName: eventName, linkType: 'o' });
    }
  },
  getHbParams: (): Record<string, unknown> => {
    if (window.om && window.om.getHbParams && getConsent()) {
      return window.om.getHbParams();
    }
    return {};
  },
};

export default Tracker;
